import { render } from "./InterestFormApp.vue?vue&type=template&id=bdda7e96"
import script from "./InterestFormApp.vue?vue&type=script&lang=js"
export * from "./InterestFormApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__